<template>
  <div class="menuTwo">
    <breadCrumb></breadCrumb>
    <base-table :tableData="tableData" @handleClick="handleClick"></base-table>
    <pagination
      @sizePageChange="paginationChangeProduct"
      :paginationDatas="paginationDataProduct"
    > </pagination>
  </div>
</template>

<script>
import pagination from "../../../../components/pagination"
import baseTable from "../../../../components/baseTable";
import breadCrumb from "../../../../components/breadCrumb";
import { permissionPage } from "../../../../api/admin"
export default {
  name: "menuSecond",
  components: {
    baseTable,
    pagination,
    breadCrumb
  },
  data() {
    return {
      routeVal:'',
       paginationDataProduct: {
          total: 0,
          currentPage: 1,
          pageSize: 10
        },
      tableData:{
          tableHeader:[{
            prop:'id',
            label:'菜单ID',
          },{
            prop:'name',
            label:'菜单名称',
          },{
            prop:'permissionLevel',
            label:'层级',
          },{
            prop:'createTime',
            label:'创建时间',
          },{
            prop:'createMan',
            label:'创建人',
          },],
          tableList:[],
          tableType:0,
        }
    };
  },
  created(){
      
      this.$route.query
      this.permissionPage(this.$route.query)
  },
  methods:{
    paginationChangeProduct(val){
        
        this.paginationDataProduct = val
        this.permissionPage(this.$route.query)
    },
    handleClick(val){
      
        this.$router.push({
          path:'third',
          query: val.val
        })
    },
    permissionPage(val){
      
        let vm = this
        permissionPage({
            page:this.paginationDataProduct.currentPage,
            pageSize:this.paginationDataProduct.pageSize,
            permissionLevel: 2, // Number(val.val.permissionLevel) +1 , 
            pid: val.id,
            permissionType: val.permissionType
        })
        .then(res => {
            
            
            vm.paginationDataProduct.total = res.totalCount 
            vm.paginationDataProduct.currentPage = res.pageNo
            vm.paginationDataProduct.pageSize = res.pageSize
            vm.tableData.tableList.splice(0,vm.tableData.tableList.length)
            res.data.map(item => {
                vm.tableData.tableList.push(item)
            })
        })
    }
  }
};
</script>

<style lang="scss" scoped>

</style>